//on production use .env 
export const APACHE_URL = process.env.REACT_APP_APACHE_URL
export const NAV_URL    = process.env.REACT_APP_NAV_URL
export const HRMIS      = process.env.REACT_APP_HRMIS 
export const HRMISPASS  = process.env.REACT_APP_NAV_PASS

/**local testing */

// let setup = {ap: '',bc:'',us:'',ps:''}
// if(localStorage.getItem("MM_SET")){
//     setup = JSON.parse(localStorage.getItem("MM_SET"))
// }
// const APACHE_URL        = setup.ap
// const NAV_URL           = setup.bc
// export const HRMIS      = setup.us 
// export const HRMISPASS  = setup.ps

/*LOGIN, REGISTER, PROFILE, RESET PASSWORD*/ 
export const GET_COMPANY            = APACHE_URL+"mildmay_api/company.php"
export const WSERVICES              = APACHE_URL+"mildmay_api/webServices.php"
export const POST_REGISTER          = APACHE_URL+"mildmay_api/register.php"
export const POST_LOGIN             = APACHE_URL+"mildmay_api/login.php"
export const POST_PASSWORD_FORGET   = APACHE_URL+"mildmay_api/forgotPassword.php"
export const POST_EDIT_PROFILE      = APACHE_URL+"mildmay_api/EditProfile.php"
export const CHANGEPASSWORD         = APACHE_URL+"mildmay_api/changePassword.php"
export const STAFF                  = APACHE_URL+"mildmay_api/staff.php"

export const APPLICANT_REGISTER     = APACHE_URL+"mildmay_api/applicantsRegister.php"
export const APPLICANT_LOGIN        = APACHE_URL+"mildmay_api/applicantsLogin.php"

/*GENERAL*/
export const EMPLOYEES  	        = NAV_URL+"api/hrpsolutions/hrmis/v1.0/employees"